window.$ = window.jQuery = require('jquery')

import Vue from 'vue'
import VueAuth from '@websanova/vue-auth'
import Notifications from 'vue-notification'
import Breadcrumbs from 'vue-2-breadcrumbs'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource';
import './registerServiceWorker'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import Datepicker from 'vuejs-datepicker';
Vue.component('datepicker', Datepicker)

import timeselector from 'vue-timeselector';
Vue.component('timeselector', timeselector)

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
Vue.component('dateTimePicker', VueCtkDateTimePicker)

import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

import VuejsDialog from 'vuejs-dialog';

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
Vue.use(VuejsDialog);

import dotenv from 'dotenv'
dotenv.config()

import moment from 'moment'

import Vuex from 'vuex'
Vue.use(Vuex)

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

Vue.component('date-range-picker', DateRangePicker);

// Filters

Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDateShort', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YY')
  }
})

Vue.filter('formatDateShortWithTime', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YY HH:mm')
  }
})

Vue.filter('formatTimeShort', function(value) {
  if (value) {
    return moment(String(value)).format('HH:mm')
  }
})

Vue.filter('formatCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('CurrencySymbol', function (value) {
  let symbol = null;
  switch (value) {
    case 'USD': symbol = '$';  break;
    case 'Sterling': symbol = '£';  break;
    case 'EUR': symbol = '€';  break;
  
    default: symbol = '£';  break;
  }

  return symbol;
});

Vue.filter('formatNumber', function (value) {
  return parseFloat(Number(value).toFixed(2));
});

Vue.filter('BOOKING_STATUS', function (value) {
  let status = [
    {
      id: 1,
      name: 'Pending',
      class: 'is-warning'
    },
    {
      id: 2,
      name: 'Confirmed',
      class: 'is-success'
    },
    {
      id: 3,
      name: 'Paid',
      class: 'is-danger'
    },
    {
      id: 4,
      name: 'Cancelled',
      class: 'is-danger'
    },
    {
      id: 5,
      name: 'Cancelled Pending',
      class: 'is-danger'
    }
  ];

  let statusObj = status.find(s => s.id === Number(value));
  if (statusObj) {
    return {
      name: statusObj.name,
      class: statusObj.class
    };
  }
});


// to Check for token verfify
router.beforeEach((to, from, next) => {
  
  const token = localStorage.getItem('token')
  let user_role = localStorage.getItem("user_role")

  // If logged in, or going to the Login page.
  if (token || to.name === 'login') {
      if (!user_role && to.name != 'login') {
        // Fetch User Role
        fetch(process.env.VUE_APP_API + 'details', {
          method: 'POST',
          headers: {
           'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.status) {
            localStorage.setItem('user_role', response.data.role)
            next()
          } 
        });
      } else {
        // Continue to page.
        next()
        
      }
    } else {
      // Not logged in, redirect to login.
      next({name: 'login'})
    }
  });


Vue.router = router
Vue.use(VueResource)
Vue.use(VueAuth, {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    rolesVar: 'role'
})
Vue.use(Notifications)
Vue.use(Breadcrumbs, {
  template:
    ' <nav class="breadcrumb" v-if="$breadcrumbs.length" aria-label="breadcrumb">\n' +
    '   <ol >\n' +
    '     <router-link tag="li" to="/" exact><a>Dashboard</a></router-link>\n' +
    '     <li v-for="(crumb, key) in $breadcrumbs" v-if="crumb.meta.breadcrumb" :key="key" aria-current="page">\n' +
    '       <router-link :to="{ path: crumb.path }">{{ getBreadcrumb(crumb.meta.breadcrumb) }}</router-link>' +
    '     </li>\n' +
    '   </ol>\n' +
    ' </nav>'
})
Vue.config.productionTip = false
window.Vue = Vue
Vue.prototype.$api = process.env.VUE_APP_API
Vue.prototype.$backendUrl = process.env.VUE_APP_URL
//Vue.prototype.$authtoken = process.env.VUE_APP_BEARER
Vue.http.options.root = process.env.VUE_APP_API

// Setup Vuex Load State Management
const store = new Vuex.Store({
  state: {
    loading: false,
    booking_accepted_status:false
  },
  mutations: {
    TOGGLE_LOAD_STATE(state) {
      state.loading = !state.loading
    },
    TOGGLE_BOOKING_ACCEPTED_STATE(state) {
      state.booking_accepted_status = !state.booking_accepted_status
    }
  },
  actions: {
    setLoadStatus(context) {
      context.commit('TOGGLE_LOAD_STATE')
    },
    setChangeAcceptedStatus(context) {
      context.commit('TOGGLE_BOOKING_ACCEPTED_STATE')
    },
  },
  getters: {
    getLoadStatus() {
      return store.state.loading
    },
    getBookingAcceptedStatus() {
      return store.state.booking_accepted_status
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
